/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Live_Caption_Latency_OffsetInputs */



/**
* | output |
* | --- |
* | "Latency offset: {value}s" |
*
* @param {Live_Caption_Latency_OffsetInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_latency_offset = /** @type {((inputs: Live_Caption_Latency_OffsetInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Latency_OffsetInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Décalage de latence : ${i?.value}s`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Latenzversatz: ${i?.value}s`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Offset di latenza: ${i?.value}s`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Смещение задержки: ${i?.value}s`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Desfase de latencia: ${i?.value}s`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`延迟偏移：${i?.value}s`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`遅延オフセット: ${i?.value}s`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`विलंबता ऑफ़सेट: ${i?.value}s`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Deslocamento de latência: ${i?.value}s`)
	return /** @type {LocalizedString} */ (`Latency offset: ${i?.value}s`)
});